import React, { useEffect, useState } from 'react';
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 51
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (time: number) => time.toString().padStart(2, '0');
  return <div className="flex flex-col items-center justify-center space-y-2 md:space-y-4 my-4 md:my-8" data-id="element-46">
      <p className="text-xs md:text-base font-semibold text-gray-700 uppercase tracking-wider" data-id="element-47">
        El precio de lanzamiento termina en:
      </p>

      <div className="flex items-center space-x-1.5 md:space-x-4" data-id="element-48">
        <div className="flex flex-col items-center" data-id="element-49">
          <div className="bg-dark text-white text-2xl md:text-5xl font-black p-2.5 md:p-4 rounded-lg shadow-inner min-w-[56px] md:min-w-[90px] text-center" data-id="element-50">
            {formatTime(timeLeft.hours)}
          </div>
          <span className="text-[10px] md:text-sm font-medium mt-1 text-gray-600" data-id="element-51">
            Horas
          </span>
        </div>

        <span className="text-2xl md:text-5xl font-black text-dark pb-4 md:pb-6" data-id="element-52">
          :
        </span>

        <div className="flex flex-col items-center" data-id="element-53">
          <div className="bg-dark text-white text-2xl md:text-5xl font-black p-2.5 md:p-4 rounded-lg shadow-inner min-w-[56px] md:min-w-[90px] text-center" data-id="element-54">
            {formatTime(timeLeft.minutes)}
          </div>
          <span className="text-[10px] md:text-sm font-medium mt-1 text-gray-600" data-id="element-55">
            Min
          </span>
        </div>

        <span className="text-2xl md:text-5xl font-black text-dark pb-4 md:pb-6" data-id="element-56">
          :
        </span>

        <div className="flex flex-col items-center" data-id="element-57">
          <div className="bg-primary text-white text-2xl md:text-5xl font-black p-2.5 md:p-4 rounded-lg shadow-inner min-w-[56px] md:min-w-[90px] text-center" data-id="element-58">
            {formatTime(timeLeft.seconds)}
          </div>
          <span className="text-[10px] md:text-sm font-medium mt-1 text-gray-600" data-id="element-59">
            Seg
          </span>
        </div>
      </div>

      <div className="bg-red-50 border border-red-200 text-red-700 px-3 py-1.5 rounded-full text-xs md:text-base font-medium flex items-center mt-2" data-id="element-60">
        <span className="mr-1.5" data-id="element-61">⚠️</span> Después sube $8.000 ARS y no vuelve a
        bajar.
      </div>

      <div className="w-full max-w-md mt-3 md:mt-6" data-id="element-62">
        <div className="flex justify-between text-xs md:text-sm font-bold mb-1.5 text-dark" data-id="element-63">
          <span className="flex items-center" data-id="element-64">
            <span className="w-2 h-2 rounded-full bg-red-500 mr-1.5 animate-pulse" data-id="element-65"></span>
            Cupos al precio de lanzamiento
          </span>
          <span data-id="element-66">68% tomados</span>
        </div>
        <div className="w-full bg-gray-200 rounded-full h-2.5 md:h-3 overflow-hidden shadow-inner" data-id="element-67">
          <div className="bg-red-500 h-full rounded-full relative overflow-hidden" style={{
          width: '68%'
        }} data-id="element-68">
            {/* Animated shimmer over the progress bar */}
            <div className="absolute top-0 left-0 right-0 bottom-0 bg-gradient-to-r from-transparent via-white/30 to-transparent -translate-x-full animate-[shimmer_2s_infinite]" data-id="element-69"></div>
          </div>
        </div>
      </div>
    </div>;
}